var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Image_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9 Copy 6",
    transform: "translate(0 -.161)",
    fill: "#f6f7fb",
    stroke: "#f2f4f9",
    strokeMiterlimit: 10,
    d: "M0 0h54v54H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18204",
    opacity: 0.798
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9 Copy 6",
    d: "M39.018 5.468a5.528 5.528 0 11-5.528 5.528 5.528 5.528 0 015.528-5.528z",
    fill: "#c7cee1"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 255",
    transform: "translate(0 .162)",
    clipPath: "url(#Image_svg__a)",
    stroke: "#f2f4f9"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16061",
    d: "M-23.557 13.723S4.3-4.152 28.7 29.508s53.675 26.747 53.675 26.747v37.026S13.92 98.768 9.316 98.962-32 96.82-32 96.82z",
    fill: "#e9ebf3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16062",
    d: "M-21.012 44.859s30.383 6.331 48.936-9.231 32.029-16.867 38.225-10.87 0 47.871 0 47.871l-67.5 3.175-19.661-3.176z",
    fill: "#c7cee1"
  })))));
}
export default SvgImage;